import { Component, OnInit } from '@angular/core';
import { LocalizationService } from '../../../services/localization.service';
import { Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-language-selection-popup',
  templateUrl: './language-selection-popup.component.html',
  styleUrls: ['./language-selection-popup.component.scss'],
})
export class LanguageSelectionPopUpComponent implements OnInit {

  eventClose: Subject<any> = new Subject();

  ngOnInit(): void {
  }

  constructor(
    private localizationService: LocalizationService,
    public dialogRef: MatDialogRef<LanguageSelectionPopUpComponent>,
  ) {
  }

  get availableLangs(): string[] {
    return this.localizationService.availableLangs;
  }

  getFlagFilePath(lang: string): string {
    return lang ? 'static/images/flags/' + lang + '.png' : '';
  }

  onClick(lang): void {
    this.localizationService.setLanguage(lang);
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
